import React from "react";
import upload from "assets/Icons/Upload.png";

type TProps = {
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  selectedFile: File | null;
  errors: string | undefined | boolean;
};

function FileInput({ onChange, selectedFile, errors }: TProps) {
  return (
    <>
      <input
        type="file"
        id="file"
        className="hidden"
        accept=".txt"
        name="inputFile"
        onChange={onChange}
      />
      <label
        htmlFor="file"
        className="flex px-3 py-3 w-full focus:outline-none bg-[#F4F4F4] cursor-pointer text-center my-5 max-w-[740px] h-[70px] font-helvetica "
      >
        <img
          src={upload}
          className="w-8 h-8 justify-center"
          alt="uploaded-file"
        />
        <p className="ml-4 my-2 font-sans">
          {selectedFile
            ? `Your File: ${selectedFile.name}` // Add space and correct string concatenation
            : "Select Your File"}
        </p>
      </label>
      <label className="font-sans text-sm text-red-700 mb-2">
        {errors}
      </label>
    </>
  );
}

export default FileInput;
